import { useState } from 'react';

import { Stack, styled } from '@liscio/ui';

import PrivacyPolicyDialog from 'components/PrivacyPolicyDialog/PrivacyPolicyDialog';
import TermsAndConditionsDialog from 'components/TermsAndConditionsDialog/TermsAndConditionsDialog';

const StyledText = styled('div')(() => ({
  cursor: 'pointer',
  fontSize: 'small',
  textAlign: 'center',
  lineHeight: '1.2rem',
}));

export const LegalDocumentsMenuItem = () => {
  const [isTermsAndConditionsOpen, setIsTermsAndConditionsOpen] =
    useState(false);
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);
  return (
    <>
      <Stack direction="column" mt={1}>
        <StyledText
          onClick={() => setIsTermsAndConditionsOpen(true)}
          data-testid="legal-documents__terms-and-conditions"
          role="button"
          tabIndex={0}
        >
          Terms & Conditions
        </StyledText>
        <StyledText
          onClick={() => setIsPrivacyPolicyOpen(true)}
          data-testid="legal-documents__privacy-policy"
          role="button"
          tabIndex={0}
        >
          Privacy Policy
        </StyledText>
      </Stack>
      <TermsAndConditionsDialog
        open={isTermsAndConditionsOpen}
        setIsOpen={setIsTermsAndConditionsOpen}
      />
      <PrivacyPolicyDialog
        open={isPrivacyPolicyOpen}
        setIsOpen={setIsPrivacyPolicyOpen}
      />
    </>
  );
};
